(function(){
  'use strict';

  var STYLE_ID='sicilus-facets-ux-css';
  var GIFT_HANDLES=['confezioni-regalo-siciliane','cesti-natalizi-aziendali','cesti-natalizi-gastronomici','box-degustazione-bundle-siciliani','box-degustazione-biologici-siciliani','esperienze-siciliane','sacchetti-regalo-prodotti-tipici-siciliani','gift-box-sicilus','gift-box-fiasconaro','regali-premium-dolce-gabbana','regali-solidali-sicilus','cesti-pasquali','ceste-pasquali-artigianali','strenne-natalizie','confezioni-pasta-basta'];
  var TYPE_HIDE_HANDLES=['vini-siciliani','liquori-artigianali'];
  var PROFILE_HANDLES={
    bundle:['box-degustazione-bundle-siciliani','box-degustazione-biologici-siciliani','esperienze-siciliane'],
    gift:GIFT_HANDLES,
    bio:['prodotti-biologici'],
    panettone:['panettoni-artigianali-siciliani','fiasconaro-panettoni-catalogo-prezzi','bonfissuto-panettoni-di-sicilia','panettoni-artigianali-peluso','panettone-dolce-e-gabbana','panettoni-artigianali-bonforno-di-modica'],
    oil:['olio-extravergine-di-oliva-siciliano','olio-biologico-siciliano','manfredi-barbera-vendita-online-olio-extravergine-di-oliva'],
    chocolate:['cioccolato-di-modica-igp'],
    cream:['creme-spalmabili-siciliane'],
    pasta:['pasta-siciliana-artigianale'],
    wine:['vini-siciliani','vini-siciliani-biologici','donnafugata-dolce-gabbana-vini-e-cornici-regalo'],
    drink:['liquori-artigianali','distillerie-russo','bevande-siciliane','bevande-analcoliche-siciliane','bibite-bona'],
    packaging:['scatole-confezioni-regalo-vuote'],
    ceramics:['ceramica-di-caltagirone','mulomerrino-ceramiche-caltagirone']
  };
  var PROFILE_ALLOW={
    bundle:{price:1,content:1,availability:1},
    gift:{price:1,composition:1,availability:1},
    bio:{price:1,type:1,brand:1,taste:1,diet:1,format:1,availability:1},
    panettone:{price:1,brand:1,taste:1,diet:1,cert:1,format:1,availability:1},
    oil:{price:1,brand:1,cert:1,format:1,availability:1},
    chocolate:{price:1,brand:1,taste:1,diet:1,cert:1,format:1,availability:1},
    cream:{price:1,brand:1,taste:1,diet:1,cert:1,format:1,availability:1},
    pasta:{price:1,brand:1,diet:1,cert:1,format:1,availability:1},
    wine:{price:1,rawType:1,brand:1,cert:1,format:1,availability:1},
    drink:{price:1,type:1,brand:1,taste:1,cert:1,format:1,availability:1},
    packaging:{price:1,format:1,availability:1},
    ceramics:{price:1,type:1,format:1,availability:1},
    general:{price:1,type:1,brand:1,taste:1,diet:1,cert:1,format:1,availability:1}
  };
  var PRIORITY={price:10,type:20,rawType:20,content:25,brand:30,taste:40,format:50,diet:60,cert:70,composition:80,availability:100};

  var LABELS={
    it:{giftType:'Tipologia regalo',availability:'Disponibilità',price:'Prezzo',budget:'Budget',type:'Tipologia',brand:'Produttore',taste:'Gusto',diet:'Esigenze alimentari',cert:'Certificazioni',occasion:'Occasione',composition:'Composizione',format:'Formato'},
    en:{giftType:'Gift type',availability:'Availability',price:'Price',budget:'Budget',type:'Type',brand:'Brand',taste:'Flavour',diet:'Dietary needs',cert:'Certifications',occasion:'Occasion',composition:'Composition',format:'Format'},
    fr:{giftType:'Type de cadeau',availability:'Disponibilité',price:'Prix',budget:'Budget',type:'Type',brand:'Marque',taste:'Saveur',diet:'Régimes alimentaires',cert:'Certifications',occasion:'Occasion',composition:'Composition',format:'Format'},
    de:{giftType:'Geschenkart',availability:'Verfügbarkeit',price:'Preis',budget:'Budget',type:'Kategorie',brand:'Marke',taste:'Geschmack',diet:'Ernährungsweise',cert:'Zertifizierungen',occasion:'Anlass',composition:'Zusammenstellung',format:'Format'},
    es:{giftType:'Tipo de regalo',availability:'Disponibilidad',price:'Precio',budget:'Presupuesto',type:'Tipo',brand:'Marca',taste:'Sabor',diet:'Necesidades alimentarias',cert:'Certificaciones',occasion:'Ocasión',composition:'Composición',format:'Formato'},
    cs:{giftType:'Typ dárku',availability:'Dostupnost',price:'Cena',budget:'Rozpočet',type:'Typ',brand:'Značka',taste:'Chuť',diet:'Stravovací požadavky',cert:'Certifikace',occasion:'Příležitost',composition:'Složení',format:'Formát'},
    hu:{giftType:'Ajándéktípus',availability:'Elérhetőség',price:'Ár',budget:'Keret',type:'Típus',brand:'Márka',taste:'Íz',diet:'Étrendi igények',cert:'Tanúsítványok',occasion:'Alkalom',composition:'Összetétel',format:'Kiszerelés'},
    ja:{giftType:'ギフトタイプ',availability:'在庫状況',price:'価格',budget:'予算',type:'種類',brand:'ブランド',taste:'フレーバー',diet:'食事条件',cert:'認証',occasion:'用途',composition:'内容',format:'サイズ'},
    lt:{giftType:'Dovanos tipas',availability:'Prieinamumas',price:'Kaina',budget:'Biudžetas',type:'Tipas',brand:'Prekės ženklas',taste:'Skonis',diet:'Mitybos poreikiai',cert:'Sertifikatai',occasion:'Proga',composition:'Sudėtis',format:'Formatas'},
    nl:{giftType:'Cadeautype',availability:'Beschikbaarheid',price:'Prijs',budget:'Budget',type:'Type',brand:'Merk',taste:'Smaak',diet:'Dieetwensen',cert:'Certificeringen',occasion:'Gelegenheid',composition:'Samenstelling',format:'Formaat'},
    no:{giftType:'Gavetype',availability:'Tilgjengelighet',price:'Pris',budget:'Budsjett',type:'Type',brand:'Merke',taste:'Smak',diet:'Kostholdsbehov',cert:'Sertifiseringer',occasion:'Anledning',composition:'Innhold',format:'Format'},
    pl:{giftType:'Rodzaj prezentu',availability:'Dostępność',price:'Cena',budget:'Budżet',type:'Rodzaj',brand:'Marka',taste:'Smak',diet:'Preferencje żywieniowe',cert:'Certyfikaty',occasion:'Okazja',composition:'Zawartość',format:'Format'},
    pt:{giftType:'Tipo de presente',availability:'Disponibilidade',price:'Preço',budget:'Orçamento',type:'Tipo',brand:'Marca',taste:'Sabor',diet:'Necessidades alimentares',cert:'Certificações',occasion:'Ocasião',composition:'Composição',format:'Formato'},
    sv:{giftType:'Presenttyp',availability:'Tillgänglighet',price:'Pris',budget:'Budget',type:'Typ',brand:'Varumärke',taste:'Smak',diet:'Kostbehov',cert:'Certifieringar',occasion:'Tillfälle',composition:'Innehåll',format:'Format'},
    uk:{giftType:'Тип подарунка',availability:'Наявність',price:'Ціна',budget:'Бюджет',type:'Тип',brand:'Бренд',taste:'Смак',diet:'Харчові потреби',cert:'Сертифікації',occasion:'Нагода',composition:'Склад',format:'Формат'}
  };

  /* SICILUS_FILTER_MODEL_V2_20261017 */
  var GIFT_TYPE_LABELS={
    it:{'Gift Box':'Gift Box','Cesto regalo':'Cesto regalo','Sacchetto regalo':'Sacchetto regalo','Strenna':'Strenna','Confezione regalo':'Confezione regalo','Scatola regalo vuota':'Scatola regalo vuota'},
    en:{'Gift Box':'Gift Box','Cesto regalo':'Gift basket','Sacchetto regalo':'Gift bag','Strenna':'Gift set','Confezione regalo':'Gift package','Scatola regalo vuota':'Empty gift box'},
    fr:{'Gift Box':'Coffret cadeau','Cesto regalo':'Panier cadeau','Sacchetto regalo':'Sac cadeau','Strenna':'Coffret festif','Confezione regalo':'Emballage cadeau','Scatola regalo vuota':'Boîte cadeau vide'},
    de:{'Gift Box':'Geschenkbox','Cesto regalo':'Geschenkkorb','Sacchetto regalo':'Geschenktüte','Strenna':'Geschenkset','Confezione regalo':'Geschenkverpackung','Scatola regalo vuota':'Leere Geschenkbox'},
    es:{'Gift Box':'Caja regalo','Cesto regalo':'Cesta regalo','Sacchetto regalo':'Bolsa regalo','Strenna':'Lote regalo','Confezione regalo':'Paquete regalo','Scatola regalo vuota':'Caja regalo vacía'},
    cs:{'Gift Box':'Dárkový box','Cesto regalo':'Dárkový koš','Sacchetto regalo':'Dárková taška','Strenna':'Dárková sada','Confezione regalo':'Dárkové balení','Scatola regalo vuota':'Prázdná dárková krabice'},
    hu:{'Gift Box':'Ajándékdoboz','Cesto regalo':'Ajándékkosár','Sacchetto regalo':'Ajándéktáska','Strenna':'Ajándékcsomag','Confezione regalo':'Ajándékcsomagolás','Scatola regalo vuota':'Üres ajándékdoboz'},
    ja:{'Gift Box':'ギフトボックス','Cesto regalo':'ギフトバスケット','Sacchetto regalo':'ギフトバッグ','Strenna':'ギフトセット','Confezione regalo':'ギフト包装','Scatola regalo vuota':'空のギフトボックス'},
    lt:{'Gift Box':'Dovanų dėžutė','Cesto regalo':'Dovanų krepšys','Sacchetto regalo':'Dovanų maišelis','Strenna':'Dovanų rinkinys','Confezione regalo':'Dovanų pakuotė','Scatola regalo vuota':'Tuščia dovanų dėžutė'},
    nl:{'Gift Box':'Geschenkbox','Cesto regalo':'Geschenkmand','Sacchetto regalo':'Geschenktas','Strenna':'Geschenkset','Confezione regalo':'Geschenkverpakking','Scatola regalo vuota':'Lege geschenkdoos'},
    no:{'Gift Box':'Gaveboks','Cesto regalo':'Gavekurv','Sacchetto regalo':'Gavepose','Strenna':'Gavesett','Confezione regalo':'Gavepakke','Scatola regalo vuota':'Tom gaveeske'},
    pl:{'Gift Box':'Box prezentowy','Cesto regalo':'Kosz prezentowy','Sacchetto regalo':'Torba prezentowa','Strenna':'Zestaw prezentowy','Confezione regalo':'Opakowanie prezentowe','Scatola regalo vuota':'Puste pudełko prezentowe'},
    pt:{'Gift Box':'Caixa presente','Cesto regalo':'Cesto presente','Sacchetto regalo':'Saco presente','Strenna':'Conjunto presente','Confezione regalo':'Embalagem presente','Scatola regalo vuota':'Caixa presente vazia'},
    sv:{'Gift Box':'Presentbox','Cesto regalo':'Presentkorg','Sacchetto regalo':'Presentpåse','Strenna':'Presentset','Confezione regalo':'Presentförpackning','Scatola regalo vuota':'Tom presentbox'},
    uk:{'Gift Box':'Подарунковий бокс','Cesto regalo':'Подарунковий кошик','Sacchetto regalo':'Подарунковий пакет','Strenna':'Подарунковий набір','Confezione regalo':'Подарункова упаковка','Scatola regalo vuota':'Порожня подарункова коробка'}
  };

  var BRAND_ALIASES=[
    {canonical:'Sicilus',aliases:['SICILUS','sicilus','Sicilus Srl','Sicilus Srl Confezioni Regalo Aziendali']},
    {canonical:'Cantina Donnafugata',aliases:['Donnafugata']},
    {canonical:'Ficodi',aliases:["Ficodi'"]},
    {canonical:'Distillerie dell’Etna F.lli Russo',aliases:['Distillerie dell’Etna – Russo Siciliano']}
  ];

  var VALUE_LABELS={
    en:{
      'Biologico':'Organic','Vegano':'Vegan','Vegetariano':'Vegetarian','Senza glutine':'Gluten-free','Senza lattosio':'Lactose-free',
      'Natale':'Christmas','Pasqua':'Easter','San Valentino':"Valentine's Day",'Regalo aziendale':'Corporate gift','Degustazione':'Tasting',
      'Dolce':'Sweet','Salato':'Savoury','Misto':'Mixed','Con vino/liquori':'With wine/spirits','Senza alcol':'Alcohol-free',
      'Pistacchio':'Pistachio','Mandorla':'Almond','Cioccolato':'Chocolate','Limone':'Lemon','Agrumi':'Citrus','Nocciola':'Hazelnut','Caffè':'Coffee'
    },
    fr:{
      'Biologico':'Biologique','Vegano':'Végan','Vegetariano':'Végétarien','Senza glutine':'Sans gluten','Senza lattosio':'Sans lactose',
      'Natale':'Noël','Pasqua':'Pâques','San Valentino':'Saint-Valentin','Regalo aziendale':"Cadeau d’entreprise",'Degustazione':'Dégustation',
      'Dolce':'Sucré','Salato':'Salé','Misto':'Mixte','Con vino/liquori':'Avec vin/spiritueux','Senza alcol':'Sans alcool',
      'Pistacchio':'Pistache','Mandorla':'Amande','Cioccolato':'Chocolat','Limone':'Citron','Agrumi':'Agrumes','Nocciola':'Noisette','Caffè':'Café'
    },
    de:{
      'Biologico':'Bio','Vegano':'Vegan','Vegetariano':'Vegetarisch','Senza glutine':'Glutenfrei','Senza lattosio':'Laktosefrei',
      'Natale':'Weihnachten','Pasqua':'Ostern','San Valentino':'Valentinstag','Regalo aziendale':'Firmengeschenk','Degustazione':'Verkostung',
      'Dolce':'Süß','Salato':'Herzhaft','Misto':'Gemischt','Con vino/liquori':'Mit Wein/Spirituosen','Senza alcol':'Alkoholfrei',
      'Pistacchio':'Pistazie','Mandorla':'Mandel','Cioccolato':'Schokolade','Limone':'Zitrone','Agrumi':'Zitrusfrüchte','Nocciola':'Haselnuss','Caffè':'Kaffee'
    },
    es:{
      'Biologico':'Ecológico','Vegano':'Vegano','Vegetariano':'Vegetariano','Senza glutine':'Sin gluten','Senza lattosio':'Sin lactosa',
      'Natale':'Navidad','Pasqua':'Pascua','San Valentino':'San Valentín','Regalo aziendale':'Regalo corporativo','Degustazione':'Degustación',
      'Dolce':'Dulce','Salato':'Salado','Misto':'Mixto','Con vino/liquori':'Con vino/licores','Senza alcol':'Sin alcohol',
      'Pistacchio':'Pistacho','Mandorla':'Almendra','Cioccolato':'Chocolate','Limone':'Limón','Agrumi':'Cítricos','Nocciola':'Avellana','Caffè':'Café'
    },
    sv:{
      'Biologico':'Ekologisk','Vegano':'Vegansk','Vegetariano':'Vegetarisk','Senza glutine':'Glutenfri','Senza lattosio':'Laktosfri',
      'Natale':'Jul','Pasqua':'Påsk','San Valentino':'Alla hjärtans dag','Regalo aziendale':'Företagsgåva','Degustazione':'Provsmakning',
      'Dolce':'Sött','Salato':'Salt','Misto':'Blandat','Con vino/liquori':'Med vin/sprit','Senza alcol':'Alkoholfritt',
      'Pistacchio':'Pistage','Mandorla':'Mandel','Cioccolato':'Choklad','Limone':'Citron','Agrumi':'Citrus','Nocciola':'Hasselnöt','Caffè':'Kaffe'
    },
    uk:{
      'Biologico':'Органічне','Vegano':'Веганське','Vegetariano':'Вегетаріанське','Senza glutine':'Без глютену','Senza lattosio':'Без лактози',
      'Natale':'Різдво','Pasqua':'Великдень','San Valentino':'День святого Валентина','Regalo aziendale':'Корпоративний подарунок','Degustazione':'Дегустація',
      'Dolce':'Солодке','Salato':'Солоне','Misto':'Змішане','Con vino/liquori':'З вином/лікером','Senza alcol':'Без алкоголю',
      'Pistacchio':'Фісташка','Mandorla':'Мигдаль','Cioccolato':'Шоколад','Limone':'Лимон','Agrumi':'Цитрусові','Nocciola':'Фундук','Caffè':'Кава'
    }
  };

  function locale(){return (document.documentElement.lang||'it').toLowerCase().split('-')[0];}
  function copy(){return LABELS[locale()]||LABELS.en;}
  function collectionHandle(){var m=(location.pathname||'').toLowerCase().match(/\/collections\/([^\/?#]+)/);return m?m[1]:'';}
  function isGiftCollection(){return GIFT_HANDLES.indexOf(collectionHandle())>-1;}
  function hideCommercialType(){return TYPE_HIDE_HANDLES.indexOf(collectionHandle())>-1;}
  function profileFor(){
    var h=collectionHandle(),found=null;
    Object.keys(PROFILE_HANDLES).some(function(k){if(PROFILE_HANDLES[k].indexOf(h)>-1){found=k;return true;}return false;});
    if(found)return found;
    if(/panetton|colomb/.test(h))return 'panettone';
    if(/regal|cesti|ceste|strenn/.test(h))return 'gift';
    if(/olio|barbera/.test(h))return 'oil';
    if(/cioccolat/.test(h))return 'chocolate';
    if(/crem.*spalm/.test(h))return 'cream';
    return 'general';
  }

  function injectStyle(){
    if(document.getElementById(STYLE_ID))return;
    var s=document.createElement('style');
    s.id=STYLE_ID;
    s.textContent='.hdt-filter-group__list-item[data-sicilus-scope-hidden="true"]{display:none!important}.hdt-filter-group__list-item[data-sicilus-empty="true"]{display:none!important}.hdt-filter-group[data-sicilus-low-value="true"]{display:none!important}.sicilus-gift-subnav{display:flex;gap:8px;overflow-x:auto;padding:0 0 16px;scrollbar-width:none}.sicilus-gift-subnav::-webkit-scrollbar{display:none}.sicilus-gift-subnav__link{flex:0 0 auto;border:1px solid #d8cdba;background:#fffdf8;color:#3e4931;border-radius:999px;padding:9px 13px;text-decoration:none;line-height:1.2}.sicilus-gift-subnav__link:hover,.sicilus-gift-subnav__link:focus-visible{border-color:#495a33;background:#f3ebdc;outline:0}.sicilus-budget-presets{display:flex;flex-wrap:wrap;gap:7px;margin:12px 0 4px}.sicilus-budget-chip{appearance:none;border:1px solid #d8cdba;background:#fffdf8;color:#51483c;border-radius:999px;padding:7px 10px;font:inherit;font-size:14px;min-height:44px;line-height:1;cursor:pointer;transition:border-color .15s ease,background .15s ease,color .15s ease}.sicilus-budget-chip:hover,.sicilus-budget-chip:focus-visible,.sicilus-budget-chip.is-active{border-color:#495a33;background:#f3ebdc;color:#354327;outline:0}.hdt-filter-group[data-sicilus-hidden="true"]{display:none!important}.hdt-filter-group__list-item[data-sicilus-brand-alias="true"]{display:none!important}.hdt-filter-group[data-sicilus-key="type"] .hdt-facet-title,.hdt-filter-group[data-sicilus-key="occasion"] .hdt-facet-title,.hdt-filter-group[data-sicilus-key="composition"] .hdt-facet-title{color:#2f4025}.hdt-main-sidebar .hdt-filter-group__list-item label{min-height:44px;display:flex;align-items:center}.hdt-main-sidebar .hdt-facets-label>span:last-child{opacity:.62;font-size:.92em}';
    document.head.appendChild(s);
  }

  function namesFor(group){return Array.prototype.map.call(group.querySelectorAll('input[name^="filter."]'),function(i){return i.name||'';});}
  function keyFor(group){
    var names=namesFor(group),joined=names.join('|');
    if(joined.indexOf('filter.v.price.')>-1)return 'price';
    if(joined.indexOf('filter.v.availability')>-1)return 'availability';
    if(joined.indexOf('filter.p.vendor')>-1)return 'brand';
    if(joined.indexOf('filter.p.m.custom.categoria_commerciale')>-1)return 'type';
    if(joined.indexOf('filter.p.m.custom.gusto')>-1)return 'taste';
    if(joined.indexOf('filter.p.m.custom.esigenze_alimentari')>-1)return 'diet';
    if(joined.indexOf('filter.p.m.custom.certificazioni')>-1)return 'cert';
    if(joined.indexOf('filter.p.m.custom.gift_occasion')>-1)return 'occasion';
    if(joined.indexOf('filter.p.m.custom.specialita_incluse')>-1)return 'content';
    if(joined.indexOf('filter.p.m.custom.composizione_regalo')>-1)return 'composition';
    if(joined.indexOf('filter.p.m.custom.formato')>-1||joined.indexOf('filter.p.m.custom.formati')>-1)return 'format';
    if(joined.indexOf('filter.p.product_type')>-1||joined.indexOf('filter.p.type')>-1)return 'rawType';
    if(joined.indexOf('filter.p.tag')>-1)return 'rawTag';
    return 'other';
  }

  function renameGroup(group,key,profile){
    var c=copy(),label;
    if(key==='price'&&isGiftCollection())label=c.budget;
    else if(key==='content')label=({it:'Specialità incluse',en:'Included specialties',fr:'Spécialités incluses',de:'Enthaltene Spezialitäten',es:'Especialidades incluidas'})[locale()]||'Included specialties';
    else if(key==='format'&&profile==='panettone')label=({it:'Peso',en:'Weight',fr:'Poids',de:'Gewicht',es:'Peso'})[locale()]||c.format;
    else if(key==='rawType')label=c.type;
    else if(key==='type'&&profile==='gift')label=c.giftType;
    else if(key==='rawTag'&&profile==='panettone')label=c.format;
    else label=c[key];
    if(!label)return;
    var text=group.querySelector('.hdt-facet-title_group > span:first-child');
    if(text)text.textContent=label;
    var summary=group.querySelector('.hdt-filter-group-summary');
    if(summary)summary.setAttribute('aria-label',label);
  }

  function itemFor(input){return input.closest('.hdt-filter-group__list-item')||input.closest('li')||input.parentElement;}
  function countNode(input){var item=itemFor(input);return item?item.querySelector('.hdt-facets-label > span:last-child'):null;}
  function countValue(input){var node=countNode(input),m=node&&node.textContent.match(/\d+/);return m?parseInt(m[0],10):null;}

  /* SICILUS_FILTER_CLEANUP_20261017 */
  function currentResultCount(){
    var node=document.querySelector('[data-sicilus-results-count]');
    var n=node?parseInt(node.getAttribute('data-sicilus-results-count'),10):NaN;
    return isNaN(n)?0:n;
  }

  function cleanFilterGroup(group,key){
    if(key==='price')return true;
    var total=currentResultCount(),useful=false,active=false,visible=0;
    var hasSelection=!!group.querySelector('input[name^="filter."]:checked');
    group.querySelectorAll('input[name^="filter."]').forEach(function(input){
      var item=itemFor(input);
      if(!item||item.getAttribute('data-sicilus-brand-alias')==='true'||item.getAttribute('data-sicilus-scope-hidden')==='true')return;
      if((key==='format'&&/^vari formati$/i.test(input.value||''))||(key==='diet'&&/^biologico$/i.test(input.value||''))){
        if(!input.checked){item.setAttribute('data-sicilus-empty','true');return;}
      }
      var count=countValue(input);
      if(input.checked){
        active=true;
        visible+=1;
        item.removeAttribute('data-sicilus-empty');
        return;
      }
      if(input.disabled||count===0||(!hasSelection&&total>0&&count===total)){
        item.setAttribute('data-sicilus-empty','true');
        return;
      }
      item.removeAttribute('data-sicilus-empty');
      visible+=1;
      if(count==null||total===0||count<total)useful=true;
    });
    var keep=active||(key==='format'?visible>1:(useful||visible>1));
    group.setAttribute('data-sicilus-low-value',keep?'false':'true');
    return keep;
  }

  function formatTagLabel(value){
    var m=String(value||'').match(/^format-(\d+)(?:-(\d+))?kg$/);
    if(m)return m[2]?m[1]+','+m[2]+' kg':m[1]+' kg';
    m=String(value||'').match(/^format-(\d+)g$/);
    return m?m[1]+' g':value;
  }

  function labelTextNode(input){
    var item=itemFor(input),label=item&&item.querySelector('label');
    if(!label)return null;
    var spans=label.querySelectorAll('.hdt-facets-label > span:first-child, .hdt-filter-group__color-label > span:first-child');
    return spans.length?spans[0]:null;
  }

  function scopeRawTagGroup(group,profile){
    if(profile!=='panettone')return false;
    var relevant=0;
    group.querySelectorAll('input[name^="filter."]').forEach(function(input){
      var item=itemFor(input),ok=/^format-/.test(input.value||'');
      if(!item)return;
      item.setAttribute('data-sicilus-scope-hidden',ok?'false':'true');
      if(ok){
        relevant+=1;
        var node=labelTextNode(input);
        if(node)node.textContent=formatTagLabel(input.value);
      }
    });
    return relevant>0;
  }

  function translateActiveFilters(profile){
    document.querySelectorAll('.hdt-active-filters__remove').forEach(function(a){
      var value=(a.textContent||'').trim(),map=GIFT_TYPE_LABELS[locale()]||GIFT_TYPE_LABELS.en;
      if(profile==='panettone'&&/^format-/.test(value))a.textContent=formatTagLabel(value);
      else if(profile==='gift'&&map[value])a.textContent=map[value];
    });
  }

  function priorityFor(key,profile){
    if(profile==='gift'||profile==='bundle'){
      var giftPriority={price:10,content:20,composition:30,availability:80};
      return giftPriority[key]||PRIORITY[key]||500;
    }
    if(profile==='panettone'){
      var panettonePriority={brand:10,taste:20,rawTag:30,format:35,price:40,diet:50,cert:60,availability:70};
      return panettonePriority[key]||PRIORITY[key]||500;
    }
    return PRIORITY[key]||500;
  }

  function injectGiftSubnav(){
    if(collectionHandle()!=='confezioni-regalo-siciliane'||document.querySelector('.sicilus-gift-subnav'))return;
    var control=document.querySelector('.hdt-main-collection-content .hdt-shop-control');
    if(!control)return;
    var paths=[
      '/collections/gift-box-sicilus',
      '/collections/box-degustazione-bundle-siciliani',
      '/collections/sacchetti-regalo-prodotti-tipici-siciliani',
      '/collections/regali-premium-dolce-gabbana',
      '/collections/regali-solidali-sicilus',
      '/collections/cesti-natalizi-gastronomici'
    ];
    var nav=document.createElement('nav');
    nav.className='sicilus-gift-subnav';
    nav.setAttribute('aria-label','Gift categories');
    paths.forEach(function(path){
      var source=document.querySelector('a[href*="'+path+'"]');
      if(!source)return;
      var a=document.createElement('a');
      a.className='sicilus-gift-subnav__link';
      a.href=source.getAttribute('href')||path;
      a.textContent=(source.textContent||'').trim();
      if(a.textContent)nav.appendChild(a);
    });
    if(nav.children.length)control.parentNode.insertBefore(nav,control);
  }

  function mergeBrandAliases(group){
    var inputs=Array.prototype.slice.call(group.querySelectorAll('input[name="filter.p.vendor"]'));
    if(!inputs.length)return;
    BRAND_ALIASES.forEach(function(set){
      var primary=inputs.find(function(i){return i.value===set.canonical;});
      var aliases=inputs.filter(function(i){return set.aliases.indexOf(i.value)>-1;});
      if(!primary||!aliases.length)return;

      if(aliases.some(function(i){return i.checked;}))primary.checked=true;
      var base=countValue(primary),sum=base==null?null:base;
      aliases.forEach(function(alias){
        var item=itemFor(alias);
        if(item)item.setAttribute('data-sicilus-brand-alias','true');
        var n=countValue(alias);
        if(sum!=null&&n!=null)sum+=n;else sum=null;
      });
      var node=countNode(primary);
      if(node&&sum!=null)node.textContent='('+sum+')';

      if(!primary.hasAttribute('data-sicilus-brand-merge')){
        primary.setAttribute('data-sicilus-brand-merge','true');
        primary.addEventListener('change',function(){
          aliases.forEach(function(alias){alias.checked=primary.checked;});
        });
      }
    });
  }

  function translateValues(group,key,profile){
    if(['type','taste','diet','cert','composition','content'].indexOf(key)===-1)return;
    var map=VALUE_LABELS[locale()]||{};
    var giftMap=GIFT_TYPE_LABELS[locale()]||GIFT_TYPE_LABELS.en;
    group.querySelectorAll('input[name^="filter."]').forEach(function(input){
      var translated=(key==='type'&&profile==='gift'&&giftMap[input.value])||map[input.value];
      if(!translated)return;
      var item=itemFor(input),label=item&&item.querySelector('label');
      if(!label)return;
      var spans=label.querySelectorAll('span');
      var target=spans.length?spans[0]:null;
      if(target&&target.textContent.trim()===input.value)target.textContent=translated;
      else{
        Array.prototype.some.call(label.childNodes,function(node){
          if(node.nodeType===3&&node.nodeValue.trim()===input.value){node.nodeValue=node.nodeValue.replace(input.value,translated);return true;}
          return false;
        });
      }
    });
  }

  function setBudget(minInput,maxInput,min,max){
    if(!minInput||!maxInput)return;
    minInput.value=min==null?'':String(min);
    maxInput.value=max==null?'':String(max);
    var target=max==null?minInput:maxInput;
    target.dispatchEvent(new Event('change',{bubbles:true}));
  }

  function budgetActive(min,max,minInput,maxInput){
    var u=new URL(location.href),mn=u.searchParams.get(minInput.name),mx=u.searchParams.get(maxInput.name),a=mn==null?null:parseFloat(mn),b=mx==null?null:parseFloat(mx),rangeMax=parseFloat(maxInput.max||'0');
    if(min==null&&max===30)return (a==null||a===0)&&b===30;
    if(min===100&&max==null)return a===100&&(b==null||b>=rangeMax);
    return a===min&&b===max;
  }

  function addBudget(group){
    if(!isGiftCollection()||group.querySelector('.sicilus-budget-presets'))return;
    var minInput=group.querySelector('input[type="number"][name$=".gte"]'),maxInput=group.querySelector('input[type="number"][name$=".lte"]');
    if(!minInput||!maxInput)return;
    var presets=[[null,30,'≤ 30 €'],[30,50,'30–50 €'],[50,75,'50–75 €'],[75,100,'75–100 €'],[100,null,'100 €+']];
    var wrap=document.createElement('div');wrap.className='sicilus-budget-presets';wrap.setAttribute('aria-label',copy().budget);
    presets.forEach(function(p){
      var b=document.createElement('button');b.type='button';b.className='sicilus-budget-chip';b.textContent=p[2];
      if(budgetActive(p[0],p[1],minInput,maxInput))b.classList.add('is-active');
      b.addEventListener('click',function(){setBudget(minInput,maxInput,p[0],p[1]);});
      wrap.appendChild(b);
    });
    var host=group.querySelector('.hdt-filter-group__display');if(host)host.insertBefore(wrap,host.firstChild);
  }

  function hideByProfile(key,profile){
    if(key==='occasion'||key==='rawTag'||key==='other')return true;
    var allowed=PROFILE_ALLOW[profile]||PROFILE_ALLOW.general;
    return !allowed[key];
  }

  function processForm(form){
    var wrappers=Array.prototype.filter.call(form.children,function(el){return el.matches&&el.matches('hdt-accordion');});
    if(!wrappers.length)return;
    var entries=wrappers.map(function(w){var g=w.querySelector('.hdt-filter-group');return {wrapper:w,group:g,key:g?keyFor(g):'other'};}).filter(function(x){return x.group;});
    var hasType=entries.some(function(x){return x.key==='type';});
    var hasFormatList=entries.some(function(x){return namesFor(x.group).indexOf('filter.p.m.custom.formati')>-1;});
    var hideType=hideCommercialType(),profile=profileFor();
    var rawTagEntry=entries.find(function(x){return x.key==='rawTag';});
    var scopedFormatTags=rawTagEntry?scopeRawTagGroup(rawTagEntry.group,profile):false;

    entries.forEach(function(x){
      x.group.setAttribute('data-sicilus-key',x.key);
      renameGroup(x.group,x.key,profile);
      if(x.key==='brand')mergeBrandAliases(x.group);
      translateValues(x.group,x.key,profile);
      cleanFilterGroup(x.group,x.key);
      var keepRawTag=x.key==='rawTag'&&profile==='panettone'&&scopedFormatTags;
      var hide=hideByProfile(x.key,profile)||(x.group.getAttribute('data-sicilus-low-value')==='true');
      if(x.key==='format'&&hasFormatList&&namesFor(x.group).indexOf('filter.p.m.custom.formato')>-1)hide=true;
      if(profile==='panettone'&&x.key==='format'&&scopedFormatTags)hide=true;
      x.group.setAttribute('data-sicilus-hidden',hide?'true':'false');
      if(x.key==='price')addBudget(x.group);
    });

    entries.sort(function(a,b){return priorityFor(a.key,profile)-priorityFor(b.key,profile);}).forEach(function(x){form.appendChild(x.wrapper);});
  }

  function processAll(){
    injectStyle();
    injectGiftSubnav();
    document.querySelectorAll('hdt-facet-filters-form form').forEach(processForm);
    translateActiveFilters(profileFor());
  }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',processAll,{once:true});else processAll();
  document.addEventListener('products:update',function(){setTimeout(processAll,0);});
  document.addEventListener('shopify:section:load',function(){setTimeout(processAll,0);});
  window.addEventListener('popstate',function(){setTimeout(processAll,0);});
})();

